import { Heading } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import React from 'react'
import { Head, VerifyRetry } from '../../../src/component'
import { usePostLoginRoute } from '../../../src/config/router'

import { TrackPageViewed } from '../../../src/integrations/monitoring'
import { CheckoutPage } from '../../../src/model'
import { useAppRouter } from '../../../src/state'
import { useCheckoutSizes } from '../../../src/utils/responsive'

export const VerifyRetryPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const { headingSize } = useCheckoutSizes()
  const router = useAppRouter()
  const postLoginRoute = usePostLoginRoute()

  const pageTitle = `${t('verifyIdentity:retry:title')} | ${t('common:brandName')}`

  const onSuccess = (): void => {
    router.push(postLoginRoute)
  }

  return (
    <>
      <Head title={pageTitle} />
      <Heading size={headingSize}>{t('verifyIdentity:retry:heading')}</Heading>
      <VerifyRetry onSuccess={onSuccess} />
      <TrackPageViewed />
    </>
  )
}
